module.exports = __webpack_public_path__ + "static/img/samajuri (3).c6657df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (3).jpg
// module id = etKu
// module chunks = 0